import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import GlobalLoader from '../../admin/shared/globalLoader';
import { setGlobalLoader } from '../../../redux/slices/globalLoader';

const UserPublicRoute = ({ component: Component }) => {
    const dispatch = useDispatch();
    const loaderState = false;

    useEffect(() => {
        dispatch(setGlobalLoader(false));
    }, []);

    return (
        <>
            {
                // (psychicData && psychicData.token) ?
                (false) ?
                    <Navigate to={{ pathname: "/dashboard" }} />
                    : loaderState ?
                        <GlobalLoader />
                        : <Component />
            }
        </>
    )
}

export default UserPublicRoute;
